var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg03(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "32px",
    height: "44px",
    viewBox: "0 0 32 44",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-2"
  }, /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-20",
    fill: "#181C4B",
    points: "0 44 0 0 32 0 32 44 16.5 44"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-22",
    fill: "#00FFC2",
    points: "21 11.96974 16 6.96974 11 11.96974 16 16.96974"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-24",
    fill: "#00FFC2",
    points: "21 21.98753 16 16.98753 11 21.98753 16 26.98753"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Fill-26",
    fill: "#00FFC2",
    points: "21 32.03027 16 27.03027 11 32.03027 16 37.03027"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg03);
export default __webpack_public_path__ + "static/media/03.7e4f78caa6a70ac8ef4d1f273dc90d0b.svg";
export { ForwardRef as ReactComponent };